export class PoliceRegion {
    TableID: string;
    SearchID: string;
    DescriptionShort?: string;
    Description?: string;
    DepartmentID?: string;

    public constructor(init?: Partial<PoliceRegion>) {
        Object.assign(this, init);
    }
}
